<div class="container-input d-flex flex-column" [class.error]="error" (keydown.enter)="onSearch()">
  <ng-content></ng-content>
  <div class="search-icons">
    <ds-icon icon="cross" (click)="onClearSearch()" class="clear-icon"></ds-icon>
    <ds-icon icon="search-line" *ngIf="searchButton" (click)="onSearch()" class="search-icon"></ds-icon>
  </div>
</div>
